import React from "react";
import { LogoFacebook, LogoInstagram } from "react-ionicons";
import classes from "./SearchingUsOnline.module.css";

export default function SearchingUsOnline() {
  const instagramURL = "https://www.instagram.com/nestal_flowers/";
  const facebookURL = "https://www.facebook.com/profile.php?id=61572445552875";

  return (
    <div className={classes.center}>
      <div className={classes.header}>חפשו אותנו באינטרנט</div>
      <LogoInstagram
        height="3rem"
        width="3rem"
        onClick={() => {
          window.location.href = instagramURL;
        }}
        style={{ margin: "1rem", cursor: "pointer" }}
      />
      <LogoFacebook
        height="3rem"
        width="3rem"
        onClick={() => {
          window.location.href = facebookURL;
        }}
        style={{ margin: "1rem", cursor: "pointer" }}
      />
    </div>
  );
}
